import {ChangeDetectionStrategy, Component, computed, inject, Signal} from '@angular/core';
import { ArticleService } from '../../services/article.service';
import { ApartmentService } from '../../services/apartment.service';

interface SitemapRoute { path: string, images: string[], lastEdit: string }

@Component({
  selector: 'homey-sitemap',
  imports: [],
  templateUrl: './sitemap.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SitemapComponent {
  private readonly articleService = inject(ArticleService);
  private readonly apartmentService = inject(ApartmentService);
  private baseRoutes = [
    '/',
    '/signup/start',
    '/about-us',
    '/common-questions',
    '/privacy-policy',
    '/how-it-works',
    '/terms-and-conditions',
    '/your-data',
    '/articles',
    '/apartments',
    '/apartments/boroughs/brooklyn',
    '/apartments/boroughs/bronx',
    '/apartments/boroughs/manhattan',
    '/apartments/boroughs/queens',
    '/apartments/boroughs/staten-island',
    '/contact',
    '/login'
  ]

  private defaultLastEdit = '2025-04-22';
  private lotteriesLastEdit = '2025-05-18';

  private allRoutes: Signal<SitemapRoute[]> = computed(
    () => {
      return this.baseRoutes.map<SitemapRoute>(
        route => ({path: route, images: [], lastEdit: this.defaultLastEdit})
      ).concat(
        this.articleService.getArticles().map(article => {
          const lastEdit = new Date(article.published) > new Date(this.lotteriesLastEdit) ? article.published : this.lotteriesLastEdit;
          return ({path: `/articles/${article.slug}`, images: [], lastEdit: lastEdit})
        }),
        this.apartmentService.apartments()?.map(apartment => ({path: `/apartments/${apartment.id}`, lastEdit: apartment.lastUpdated ,images: apartment.photos.map(
          photo => `https://www.myhomey.io${photo.header}`
          )})) ?? []
      );
    }
  )

  public readonly xml = computed(
    () => {
      return `
      <?xml version="1.0" encoding="UTF-8"?>
      <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:image="http://www.google.com/schemas/sitemap-image/1.1">
        ${this.allRoutes().map(route => `
            <url>
                <loc>https://www.myhomey.io${route.path}</loc>
                ${route.images.map(image => `
                    <image:image>
                        <image:loc>${image}</image:loc>
                    </image:image>`).join('\n')}
                <lastmod>${new Date(route.lastEdit).toISOString()}</lastmod>
                <priority>1.0</priority>
            </url>`).join('\n')}
      </urlset>`;
    });
}
